import React from 'react'
import { Navigate } from "react-router-dom"
import { jwtDecode } from "jwt-decode"

function HomeRedirect() {
    const token = localStorage.getItem("token")
    if (!token) return <Navigate to="/" replace />

    let user;
    try {
        user = jwtDecode(token)?.apirest?.objeto
    } catch {
        return <Navigate to="/" replace />
    }

    const puesto = Number(user.puesto)

    if (puesto === 6 || puesto === 7) {
        return <Navigate to="/normas" replace />
    }

    return <Navigate to="/home" replace />
}

export default HomeRedirect